import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    books: [],
    loadingBooks: false,
};

const loadLibraryBooks = (state) => {
    return {
        ...state,
        loadingBooks: true,
    };
};

const setLibraryBooks = (state, action) => {
    let tmp = [...action.books];
    return {
        ...state,
        books: tmp,
        loadingBooks: false,
    };
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOAD_LIBRARY_BOOKS:
            return loadLibraryBooks(state);
        case actionTypes.SET_LIBRARY_BOOKS:
            return setLibraryBooks(state, action);

        default:
            return state;
    }
};
export default reducer;
